import React, {PropTypes} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {fetchResults, clearQueryResults} from '../actions';
import {fetchAnnotatedTexts} from '../../home/actions';
import queryHelper from '../../../helpers/queryHelper';
import AdvancedSearchBar from '../components/AdvancedSearchBar';
import {browserHistory} from 'react-router';
import {query, tagIndexRoute, structuresRoute} from '../../../constants/public-routes';
import {apiRoutes} from '../../../api/api';
import {getIdFromRelation} from '../../app/selectors';
import {FormattedMessage} from 'react-intl';
import {scroller, Element} from 'react-scroll';
import SearchResults from '../components/SearchResults';
import {SEARCH_TYPE_FILTERS} from "../../../constants/dia";

let queryRoute = query;

class AdvancedSearch extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.pushQuery = this.pushQuery.bind(this);
    this.changeUIQuery = this.changeUIQuery.bind(this);
    this.changePage = this.changePage.bind(this);
    this.state = {
      page: props.initialPage,
      query: props.initialQuery
    };
  }

  componentDidMount() {
    let {fetchResults, initialQuery, initialPage, clearQueryResults, fetchAnnotatedTexts, lang} = this.props;
    fetchAnnotatedTexts(lang);
    clearQueryResults();
    this.setState({query: initialQuery, page: initialPage});
    if (initialQuery.query || initialQuery.filters.articleLabel || initialQuery.filters.tags) {
      if (!initialQuery.filters) {
        initialQuery.filters = {};
      }
      initialQuery.filters.language = [lang];
      fetchResults(initialQuery);
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.lastUpdated !== this.props.lastUpdated && !nextProps.initial) {
      scroller.scrollTo('results', {
        duration: 500,
        delay: 25,
        smooth: true,
      });
    }
    let nextQuery = Object.assign({}, nextProps.initialQuery, {offset: 0, limit: 0});
    let thisQuery = Object.assign({}, this.props.initialQuery, {offset: 0, limit: 0});
    if (JSON.stringify(nextQuery) !== JSON.stringify(thisQuery)) {
      this.setState({page: 1});
    }
    if (nextProps.initialPage !== this.props.initialPage) {
      this.setState({page: nextProps.initialPage});
    }
  }

  pushQuery(value) {
    this.changeUIQuery(value);
    let {lang} = this.props;
    browserHistory.push(queryRoute(lang, queryHelper.queryToUri(value)));
  }

  changePage(page) {
    let {lang, fetchResults} = this.props;
    let {query} = this.state;
    let queryString = queryHelper.queryToUri(query) || '';
    if (queryString !== '') {
      queryString += '&page=' + page;
    }
    else {
      queryString = '?page=' + page;
    }
    browserHistory.push(queryRoute(lang, queryString));
    this.setState({page});
    fetchResults(Object.assign({}, query, {offset: (page - 1) * 10, limit: 10}));
  }

  changeUIQuery(query) {
    this.setState({query});
  }

  getFeedURI(q) {
    let params = queryHelper.getURLQuery(q);
    params.limit = 50;
    return apiRoutes.feeds.query(params);
  }

  render() {
    let {items, isFetching, fetchResults, initial, texts, lang, meta, intl} = this.props;
    let {query, page} = this.state;
    let {pushQuery, getFeedURI, changeUIQuery, changePage} = this;
    let feedURI = getFeedURI(query);
    if (!(query.filters.type && query.filters.type.length > 0)) {
      query.filters.type = [].concat(SEARCH_TYPE_FILTERS);
    }
    if (!(query.filters.publication && query.filters.publication.length > 0)) {
      query.filters.publication = texts.map(text => {
        return text.canonical;
      });
    }
    if ((query.filters.tags && query.filters.tags.length > 0) || (query.filters.articleLabel)) {
      query.filters.type = ['structure'];
    }

    let typeOptions = SEARCH_TYPE_FILTERS.map((type) => {
      return {value: type, label: <FormattedMessage id={type}/>};
    });
    return (
      <div>
        <AdvancedSearchBar publications={texts} typeOptions={typeOptions} feedURI={feedURI} tagIndexRoute={tagIndexRoute(lang)} lawIndexRoute={structuresRoute(lang)} query={query}
                           queryObjChange={value => {
                             changeUIQuery(value);
                           }} startSearch={() => {
          pushQuery(query);
          if (!query.filters) {
            query.filters = {};
          }
          query.filters.language = [lang];
          fetchResults(query);
        }} queryChange={(queryText) => {
          let obj = query;
          obj.query = queryText;
          changeUIQuery(obj);
        }}>
          <h1><FormattedMessage id="search"/></h1>
        </AdvancedSearchBar>
        <Element name="results"><SearchResults isFetching={isFetching} initial={initial} meta={meta} intl={intl}
                                               items={items} changePage={changePage} page={page}/></Element>
      </div>
    );
  }
}

AdvancedSearch.propTypes = {
  items: PropTypes.array,
  meta: PropTypes.object,
  intl: PropTypes.object,
  lastUpdated: PropTypes.number,
  isFetching: PropTypes.bool,
  lang: PropTypes.string,
  initialQuery: PropTypes.object,
  initialPage: PropTypes.number,
  initial: PropTypes.bool,
  texts: PropTypes.array,
  fetchResults: PropTypes.func,
  clearQueryResults: PropTypes.func,
  fetchAnnotatedTexts: PropTypes.func,
};

function mapStateToProps(state, ownProps) {
  const {searchresults, annotatedTexts, intl} = state;
  let texts = annotatedTexts.items ? annotatedTexts.items.map(item => {
    return {
      id: item.id,
      canonical: getIdFromRelation(item, 'publication'),
      label: item.attributes.label || intl.messages.noStructureLabel,
      order: item.attributes.order
    };
  }) : [];
  const {search} = ownProps.location || '';
  const {items, isFetching, lastUpdated, meta} = searchresults;
  let initial = !lastUpdated && !isFetching;
  const {lang} = ownProps.params;
  let structures = [];
  let articles = [];
  let annotations = [];
  items.forEach(item => {
    if (item.attributes.model_type === 'structure') {
      structures.push(item);
    }
    else if (item.attributes.model_type === 'article') {
      articles.push(item);
    }
    else {
      annotations.push(item);
    }
  });

  return {
    items: structures.concat(articles, annotations),
    meta,
    intl,
    lastUpdated,
    isFetching,
    lang,
    initialQuery: queryHelper.objectifyUri(search),
    initialPage: Number(queryHelper.getURLParameter(search, 'page')) || 1,
    initial,
    texts
  };
}

function mapDispatchToProps(dispatch) {
  return {
    fetchResults: bindActionCreators(fetchResults, dispatch),
    clearQueryResults: bindActionCreators(clearQueryResults, dispatch),
    fetchAnnotatedTexts: bindActionCreators(fetchAnnotatedTexts, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(AdvancedSearch);



/** WEBPACK FOOTER **
 ** ./src/modules/search/containers/AdvancedSearch.js
 **/